import { FC, PropsWithChildren, ReactElement } from "react";

import Grid from "@mui/material/Grid";
import { Container, Typography } from "@mui/material";
import { ActionButtonProps } from "./ActionButton";

interface ActionBubbleProps {
  title?: string;
  titleSlot?: ReactElement;
  isHistorical?: boolean;
  primaryActionSlot?: ReactElement<ActionButtonProps>;
  secondaryActionSlot?: ReactElement<ActionButtonProps>;
}

export const ActionBubble: FC<PropsWithChildren<ActionBubbleProps>> = ({
  title,
  titleSlot,
  isHistorical,
  primaryActionSlot,
  secondaryActionSlot,
  children,
}) => {
  return (
    <Container disableGutters>
      <Grid
        container
        direction={"row"}
        spacing={2}
        justifyContent={"flex-end"}
        alignItems="flex-start"
      >
        <Grid
          item
          xs
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          {getTitleElement(title, titleSlot)}
          <Grid item>{children}</Grid>
        </Grid>
        {!isHistorical && (
          <Grid
            container
            item
            spacing={1}
            direction={"row"}
            xs={"auto"}
            justifyContent={"flex-end"}
            alignItems="flex-start"
          >
            {primaryActionSlot && <Grid item>{primaryActionSlot}</Grid>}
            {secondaryActionSlot && <Grid item>{secondaryActionSlot}</Grid>}
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

function getTitleElement(title?: string, titleSlot?: ReactElement) {
  if (titleSlot) {
    return titleSlot;
  } else if (title) {
    return (
      <Grid item>
        <Typography variant={"h6"} sx={{ lineHeight: "32px" }}>
          {title}
        </Typography>
      </Grid>
    );
  } else {
    return null;
  }
}
